const UnsplashOptions = {
	method: 'GET',
	qs: { client_id: '87d65f33bedf2944ee1146f5a30ff235a6b37b4faa403b0b877f02f4fbb36a40' }
};

export default UnsplashOptions;



// WEBPACK FOOTER //
// ./src/Keys/UnsplashOptions.js